var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EventIcon from '@web/components/Settings/Events/EventIcon';
import { ACTIVITY_COLORS } from '@web/config';
import { ApplicationEnum } from '@workalizer/shared/enums';
import { format } from 'date-fns';
var MAX_TOOLTIP_TITLE_LENGTH = 45;
var APPS_WITH_EVENT_ACTION_ICON = new Set([
    ApplicationEnum.DRIVE,
    ApplicationEnum.CHAT
]);
export function DailyTimelineTooltipLine(_a) {
    var items = _a.items;
    var item = items[0];
    var count = items.length;
    var timeLabel = count > 1
        ? (function () {
            var _a;
            var endDate = items.reduce(function (maxEnd, current) {
                var _a;
                var currentEnd = (_a = current.endDate) !== null && _a !== void 0 ? _a : current.startDate;
                return currentEnd > maxEnd ? currentEnd : maxEnd;
            }, (_a = item.endDate) !== null && _a !== void 0 ? _a : item.startDate);
            return "".concat(format(item.startDate, 'HH:mm'), "-").concat(format(endDate, 'HH:mm'));
        })()
        : item.endDate
            ? "".concat(format(item.startDate, 'HH:mm'), "-").concat(format(item.endDate, 'HH:mm'))
            : "".concat(format(item.startDate, 'HH:mm'), " -");
    var title = item.title.length > MAX_TOOLTIP_TITLE_LENGTH
        ? "".concat(item.title.slice(0, MAX_TOOLTIP_TITLE_LENGTH), "...")
        : item.title;
    var titleLabel = count > 1 ? "".concat(title, " (").concat(count, ")") : title;
    var showActionIcon = APPS_WITH_EVENT_ACTION_ICON.has(item.type) && Boolean(item.action);
    return (_jsxs("span", __assign({ className: "flex items-start gap-1.5" }, { children: [_jsx("span", __assign({ className: "shrink-0 pt-0.5" }, { children: timeLabel })), _jsx("span", __assign({ "data-testid": "timeline-event-type-badge", className: "shrink-0 px-2 inline-flex text-sm leading-5 font-semibold rounded-full py-0.5 bg-".concat(ACTIVITY_COLORS[item.type].color, " text-gray-900") }, { children: item.type })), showActionIcon && (_jsx("span", __assign({ "data-testid": "timeline-event-action-icon", className: "h-5 w-5 shrink-0 text-gray-500 pt-0.5" }, { children: _jsx(EventIcon, { action: item.action }) }))), _jsx("span", __assign({ className: "break-words" }, { children: titleLabel }))] })));
}
